import React from 'react';
import graph from './graph';

import { toast } from 'react-toastify';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { ProductCategoryModel } from 'models';
import { useMutation } from '@apollo/client';
import { isEmptyObject } from 'helpers/formatObject';

export default function AssignCategory({ id, active, refetch, shop }) {
  const { userToken } = useSelector((state) => state.auth);

  const [assignment, { loading }] = useMutation(graph.assignment.query, {
    context: {
      serviceName: graph.assignment.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onAssign = async (selected, onClose) => {
    try {
      const { data, errors } = await assignment({
        variables: {
          coupon_id: id,
          assignment_type: 'CATEGORY',
          product_category_ids: selected[0]?.id,
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.assignment.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {}
  };

  return (
    <>
      <ProductCategoryModel
        isPopup
        isAssign
        disabled={loading}
        onAssign={onAssign}
        assigning={loading}
        title="اختصاص مجموعه"
        initFilter={{shop_id: shop?.id}}
        action={
          <Button
            fullWidth
            size="medium"
            color="primary"
            variant={active ? 'contained' : 'text'}
            sx={{ bgcolor: !active && 'primary.lighter' }}
          >
            مجموعه
          </Button>
        }
      />
    </>
  );
}
